module.exports = __webpack_public_path__ + "static/media/DSC_0348 (2).07229def.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0348 (2).jpg
// module id = 666
// module chunks = 0